import { Box, DashboardModule, SidebarModal } from '@domain-group/suit-theme'

import { useRelations } from '@hooks/useUser'

import type { UserModel } from '@models/types'

interface UserProps {
  user: UserModel,
}

const User = (props: UserProps) => {
  const { user } = props

  const { image } = useRelations(user)

  if (!user.id){
    return null
  }

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      title="Created By"
    >
      <SidebarModal.User
        boxProps={{
          paddingX: 'large',
        }}
        disableHover
        imageUrl={image.square_url}
        title={user.full_name}
        // @ts-expect-error TS2339
        subtitle={user.email}
      />
    </DashboardModule>
  )
}

export default User
